import React from 'react';
import Description from 'components/Description/Description';
import Heading from 'components/Heading/Heading';
import styled from 'styled-components/macro';
import { Col, Row } from 'antd';

import { numberWithCommas } from 'utils/helpers/helpers';
import renoCalculatorBuildingImage from './images/reno-header-icon.png';

const StyledRenoCalculatorBackground = styled.div`
  ${props => `background-image: linear-gradient(${props.theme.color.primary}, ${props.theme.color.darkPrimary})`};
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  padding: 12px;
`;

const RenoCalculatorHeader = ({ estimatedTotalCost = 0, ...props }) => {
  return (
    <StyledRenoCalculatorBackground>
      <Row>
        <Col span={24} md={{ span: 16, offset: 4 }} lg={{ span: 8, offset: 8 }}>
          <Description color="white" size="regular" align="center" style={{ marginBottom: 0 }}>
            Estimated Total Cost
          </Description>
        </Col>
      </Row>
      <Row gutter={16} type="flex" justify="space-between" align="middle">
        <Col span={24}>
          <Row type="flex" justify="space-between" align="middle">
            <Col span={0} md={2}>
              <img src={renoCalculatorBuildingImage} alt="Renovation calculator helps you calculate the estimation cost." />
            </Col>
            <Col span={24} md={20}>
              <Heading color="white" size="sub" align="center" bold style={{ marginBottom: 0 }}>
                RM {numberWithCommas(estimatedTotalCost)}
              </Heading>
            </Col>
            <Col span={0} md={2}>
              <img src={renoCalculatorBuildingImage} alt="Estimation cost for renovation based on your preference." />
            </Col>
          </Row>
        </Col>
      </Row>
    </StyledRenoCalculatorBackground>
  );
};

export default RenoCalculatorHeader;
